// Ruban « DÉMO » discret superposé sur l'image des contenus de démonstration.
export const DemoRibbon = ({ className = "" }) => (
  <span
    data-testid="demo-ribbon"
    className={`pointer-events-none absolute bottom-2 left-2 z-20 inline-flex items-center gap-1 rounded-md bg-slate-900/65 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-white/95 backdrop-blur-sm shadow-sm ${className}`}
  >
    Démo
  </span>
);

export default DemoRibbon;
